var req = require("!!/opt/build/repo/node_modules/pug-loader/index.js!/opt/build/repo/src/app/ehs/views/unsafe-condition/unsafe-condition-step1/unsafe-condition-step1.component.pug");
module.exports = (req['default'] || req).apply(req, [])